module.exports = "/_next/static/images/a11ea0c9100b42a51f783b8f9dcd39b8-ajuste_limite.gif.webp";